@import "../../../../themes/site/default/assets/common_helpers_non_liquid.scss";

.search-bar {
  margin: 0 auto;
  max-width: 35rem;
  position: relative;

  input.form-control {
    @include where-themed-content-root {
      background: transparent;
      -webkit-appearance: none; /* safari won't let us style search inputs by default */
      padding: 18px 45px;
      font-size: 16px;
      line-height: 22px;
      border-radius: 6px;

      &::-webkit-search-cancel-button {
        display: none;
      }

      &:not(:placeholder-shown) {
        &+ .search-bar__close {
          display: block;
        }
      }
    }
  }

  &__field-wrapper {
    position: relative;
  }

  &__glass {
    &__active {
      cursor: pointer;
    }

    svg {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 23px;
      left: 15px;
    }
  }

  &__close {
    display: none;

    svg {
      cursor: pointer;
      width: 14px;
      height: 14px;
      position: absolute;
      top: 23px;
      right: 20px;

      background: #B2ADAD;
      border-radius: 100px;
      color: #fff;
      padding: 2px;
    }
  }

  .search-bar__btn {
    display: none;
  }
}
